import { render, staticRenderFns } from "./TeamUsers.vue?vue&type=template&id=80dbb6ea&"
import script from "./TeamUsers.vue?vue&type=script&lang=js&"
export * from "./TeamUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports